import axios from 'axios'
import { host } from '../../configuraciones'
import {createAsyncThunk,createSlice} from '@reduxjs/toolkit'

//constantes
const dataInicial = {
    data: {
        data:{}
    },
    guias:[],
    error:null
}
//types
const OBTENER_GUIA_MAGUEY_EXITO= 'OBTENER_GUIA_MAGUEY_EXITO'
const AGREGAR_GUIA_MAGUEY_EXITO= 'AGREGAR_GUIA_MAGUEY_EXITO'
const OBTENER_GUIA_PREDIO_BY_NUMERO_PREDIO_EXITO = 'OBTENER_GUIA_PREDIO_BY_NUMERO_PREDIO_EXITO,'
const ACTUALIZAR_GUIA_MAGUEY_EXITO= 'ACTUALIZAR_GUIA_MAGUEY_EXITO'
const AGREGAR_GUIA_MAGUEY_LISTA_EXITO = 'AGREGAR_GUIA_MAGUEY_LISTA_EXITO'
const OBTENER_GUIA_BY_IDENTIFICADOR_GUIA_EXITO = 'OBTENER_GUIA_BY_IDENTIFICADOR_GUIA_EXITO'
const AGREGAR_GUIA_EXITO = 'AGREGAR_GUIA_EXITO'
const OBTENER_GUIA_MAGUEY_EXITO_CONSULTA = 'OBTENER_GUIA_MAGUEY_EXITO_CONSULTA'

export const obtenerGuiaMaguey = createAsyncThunk(
    OBTENER_GUIA_MAGUEY_EXITO,
    async () => {
        try {
            const fullUrl = host + `Guias/obtenerTodoGuiaInfo`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error);
        }
    }
)

export const agregarNuevaGuia = createAsyncThunk(
    AGREGAR_GUIA_MAGUEY_EXITO,
    async (data) => {
        try {
            const fullUrl = host + `Guias/agregarNuevaGuia`
            const result = await axios.post(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const agregarNuevaListaGuia = createAsyncThunk(
    AGREGAR_GUIA_MAGUEY_LISTA_EXITO,
    async (data) => {
        try {
            const fullUrl = host + `Guias/agregarNuevaListaGuia`
            const result = await axios.post(fullUrl, data)
            return result
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)
export const agregarGuia = createAsyncThunk(
    AGREGAR_GUIA_EXITO,
    async (data) => {
        try {
            const fullUrl = host + `Guias/generarGuias`
            let result = await axios.post(fullUrl, data)
            return result
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

export const actualizarGuiaMaguey = createAsyncThunk(
    ACTUALIZAR_GUIA_MAGUEY_EXITO,
    async (data) => {
        try {
            const fullUrl = host + `Guias/actualizarGuias`
            const result = await axios.put(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)



export const obtenerGuiaPredioByNumeroPredio = createAsyncThunk(
    OBTENER_GUIA_PREDIO_BY_NUMERO_PREDIO_EXITO,
    async (data) => {
      
        try {
            const fullUrl = host + `Guias/obtenerGuiaPredioByNumeroPredio/${Number(data)}`
            const res = await axios.get(fullUrl)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)



export const obtenerGuiaByIdentificador = createAsyncThunk(
    OBTENER_GUIA_BY_IDENTIFICADOR_GUIA_EXITO,
    async (data) => {
        try {
            const fullUrl = host + `Guias/obtenerGuiaByIdentificador/${(data)}`
            const res = await axios.get(fullUrl)
            return res
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

export const obtenerGuiaMagueyConsultaGuia = createAsyncThunk(
    OBTENER_GUIA_MAGUEY_EXITO_CONSULTA,
    async (numeroGuia) => {
        try {
            const fullUrl = host + `Guias/obtenerTodoGuiaInfoConsultaGuia/${numeroGuia}`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error);
        }
    }
)

export const guiaMagueySlice = createSlice({
    name: 'guiaMagueySlice',
    initialState: dataInicial,
    reducers: {
        setInitialData(state, {payload}){
        return dataInicial
        }

       
    },
    extraReducers: {
      
        [obtenerGuiaMaguey.fulfilled]: (state, { payload }) => {
            state.guias = payload
        },
        [agregarNuevaGuia.fulfilled]: (state, { payload }) => {
         
        },

        [agregarNuevaListaGuia.fulfilled]: (state, { payload }) => {
         
        },

        [agregarNuevaListaGuia.rejected]: (state, { payload }) => {
            state.error = payload.error
        },

        [actualizarGuiaMaguey.fulfilled]: (state, { payload }) => {
       
        },

        [obtenerGuiaPredioByNumeroPredio.fulfilled]: (state, { payload }) => {
            state.data = payload.data
        },

        [obtenerGuiaByIdentificador.fulfilled]: (state, { payload }) => {
            state.data = payload.data
        },

        
        [obtenerGuiaByIdentificador.rejected]: (state, { payload }) => {
            state.error = payload.error
        },
    },
})

export const { setInitialData
} = guiaMagueySlice.actions
export const GuiaMagueyReducerUsuarioAgricola = guiaMagueySlice.reducer
